import {
  Button,
  Stack,
  type SxProps,
  type Theme,
  Typography,
} from '@mui/material';
import { Show, useIsMobile } from '@side/pantry';
import Image, { type ImageProps } from 'next/image';
import { SideSupport } from '../SideSupport/SideSupport';

interface Props {
  errorMessage?: string;
  svg: ImageProps['src'];
  title?: string;
  sx?: SxProps<Theme>;
  subtitle?: string;
  onRetry?: () => void;
}

export function WholePageError({
  errorMessage = 'Try reloading the page to fix. If this issue persists, please',
  subtitle,
  title,
  svg,
  sx,
  onRetry,
}: Props) {
  const isMobile = useIsMobile('md');
  const handleReloadPage = (): void => {
    window.location.reload();
  };

  return (
    <Stack sx={{ alignItems: 'center', gap: 1.5, ...sx }}>
      <Image alt="Error Banner" src={svg} />
      <Show when={title}>
        <Typography variant="h3" component="h2" sx={{ mt: 2.5 }}>
          {title}
        </Typography>
      </Show>
      <Typography
        variant={isMobile ? 'subtitle2' : 'subtitle1'}
        sx={{ maxWidth: '32rem', textAlign: 'center', color: 'text.secondary' }}
      >
        <Show when={!subtitle} fallback={subtitle}>
          {errorMessage} contact <SideSupport /> for assistance.
        </Show>
      </Typography>
      <Button
        variant="contained"
        color="error"
        onClick={onRetry ?? handleReloadPage}
        sx={{ mt: 1.5, width: 'fit-content' }}
      >
        {onRetry ? 'Try Again' : 'Refresh Page'}
      </Button>
    </Stack>
  );
}
